import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { formSummarySelector } from '../../../../store/modules/steps/selectors';
import { CustomSelectType, FormControlType, FormStep, StepsState } from '../../../../model/global';
import { getFormSummaryField } from '../../../utils';
import { CustomFormFieldState } from '../../../FormControls/CustomFormField/CustomFormField';

type Props = {
	sliceKeyName: string;
	sliceTitle: string;
	formFieldsList: FormControlType[];
	theStep: FormStep;
}

const ResumeSlice: React.FC<Props> = ({ sliceKeyName, sliceTitle, formFieldsList, theStep }) => {

	const summary = useSelector(formSummarySelector) as StepsState['formSummary']
	// const step = useSelector(currentStepSelector) as FormStep<'main'> // used for translations

	const getSummaryFieldValue = (field: CustomFormFieldState): string => {
		let value = '';
		switch (field.originalField.fieldType) {
			case 'select': {
				// get the value from the options
				if (field.options && field.options.length > 0) {
					const val1 = field.options.find(f => f.value === field.value);
					if (val1) value = (val1.label || '').toString();
				} else if ((field.originalField as CustomSelectType).optionsGroup && (field.originalField as CustomSelectType).optionsGroup.length > 0) {
					// crunch the multidimensional array into a single one
					const group = (field.originalField as CustomSelectType).optionsGroup.flatMap(o => o.options).filter(e => e);
					const optionSelected = group.find(o => o?.value === field.value);
					if (optionSelected) {
						// take the label for display purposes
						value = optionSelected.label;
					} else {
						// as a backup, use the raw value
						value = field.value;
					}

				} else if ((field.originalField as CustomSelectType).options && (field.originalField as CustomSelectType).options.length > 0) {
					const val3 = (field.originalField as CustomSelectType).options.find(f => f.value === field.value);
					if (val3) value = (val3.label || '').toString();
				} else {
					value = field.value
				}
				break
			}
			case 'checkbox': {
				// check if is checked. Return something like 'checked' or 'unchecked'
				value = field.checked ? theStep.stepData.fieldTranslations.checked : theStep.stepData.fieldTranslations.unchecked
				break
			}
			case 'file': {
				// return something like 'attached filed'
				value = theStep.stepData.fieldTranslations.attachedField
				break
			}
			default: {
				value = field.value || '-'
				break
			}
		}

		return value || '';
	}

	return (
		<div key={sliceKeyName}>
			<div className={'resume-content-title'}>{sliceTitle}</div>
			<div className="uk-grid uk-child-width-1@s uk-child-width-1-3@m">
				{formFieldsList?.map(fieldControl => {
					// get the current value from redux
					const item = getFormSummaryField(summary, theStep.stepTemplate, fieldControl.name);
					if (!item) return
					return (<div className="uk-flex uk-flex-column" key={item.originalField.id || uuidv4()}>
						<span className={'resume-content-label'}>{item.originalField.title || item.name}</span>
						<p className={'resume-content-detail'}>{getSummaryFieldValue(item)}</p>
					</div>)
				})}
			</div>
		</div>
	)
};

export default memo(ResumeSlice);




